const MAX_FILE_SIZE_BYTES = 150 * 1024 * 1024;
const ALLOWED_FILE_EXTENSIONS = [
  '.png',
  '.jpg',
  '.jpeg',
  '.mov',
  '.mp4',
  '.pdf',
  '.txt',
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.ppt',
  '.pptx',
] as const;
const ALLOWED_MIME_PREFIXES = ['image/', 'video/'] as const;
const ALLOWED_FILE_EXTENSION_SET = new Set<string>(ALLOWED_FILE_EXTENSIONS);

const getFileExtension = (fileName: string) => {
  const dotIndex = fileName.lastIndexOf('.');
  if (dotIndex < 0) {
    return '';
  }
  return fileName.slice(dotIndex).toLowerCase();
};

export const validateUploadFile = (file: File): string | null => {
  const extension = getFileExtension(file.name);
  const hasAllowedExtension = ALLOWED_FILE_EXTENSION_SET.has(extension);
  const hasAllowedMime = ALLOWED_MIME_PREFIXES.some((prefix) =>
    (file.type || '').startsWith(prefix)
  );

  if (!hasAllowedExtension && !hasAllowedMime) {
    return 'unsupported file type';
  }
  if (file.size > MAX_FILE_SIZE_BYTES) {
    return 'file is larger than 150MB';
  }
  return null;
};

export const getSkippedFilesMessage = (
  unsupportedFiles: string[],
  oversizedFilesCount: number
) => {
  const messageParts: string[] = [];
  if (unsupportedFiles.length > 0) {
    messageParts.push(
      `Unsupported files were not uploaded: ${unsupportedFiles.join(
        ', '
      )}. Allowed formats: PNG, JPG, JPEG, MOV, MP4, PDF, TXT, DOC, DOCX, XLS, XLSX, PPT, PPTX.`
    );
  }
  if (oversizedFilesCount > 0) {
    messageParts.push(
      `${oversizedFilesCount} file(s) exceeded the 150MB limit and were skipped.`
    );
  }
  return messageParts.join(' ');
};
